import { CommonModule } from '@angular/common';
import { Component, Input, model } from '@angular/core';
import { SelectDropdownComponent } from '@app/components/select-dropdown';
import { TextInputComponent } from '@app/components/text-input';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ContractCompanyType,
  ContractPaymentType,
  EnterpriseTenantContract,
} from '@skyfit/core-data-library';
import moment from 'moment';

@Component({
  selector: 'app-contract-form',
  standalone: true,
  imports: [
    TextInputComponent,
    SelectDropdownComponent,
    TranslatePipe,
    CommonModule,
  ],
  templateUrl: './contract-form.component.html',
  styleUrls: ['./contract-form.component.css'],
})
export class ContractFormComponent {
  contract = model({} as EnterpriseTenantContract);
  @Input() isReadMode: boolean;
  public readonly paymentTypes = Object.values(ContractPaymentType);
  public readonly companyTypes = Object.values(ContractCompanyType).filter(
    (type) => type !== ContractCompanyType.Contract
  );

  public formattedDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
  }

  public updateDate(field: string, event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.contract.set({
      ...this.contract(),
      [field]: moment.utc(value).toDate(),
    });
  }

  public updateContractProperty(
    field: keyof EnterpriseTenantContract,
    value: string
  ): void {
    this.contract.update((contract) => ({ ...contract, [field]: value }));
  }
}
